import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description DollarExchange icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { DollarExchange } from '@sravni/design-system-icons'
 *
 * <DollarExchange />
 * ```
 */
var DollarExchange = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "DollarExchange", viewBox: "0 0 22 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M11 5.357V6.43M11 13.572v1.071M13.132 8.094c-.056-.929-.746-1.665-1.596-1.665H10.36c-.832 0-1.505.748-1.505 1.67 0 .767.47 1.435 1.139 1.621l2.009.56c.67.187 1.138.855 1.138 1.621 0 .923-.674 1.67-1.504 1.67h-1.175c-.852 0-1.542-.738-1.597-1.669", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M5.285 4.365c1.439-1.373 3.426-2.222 5.622-2.222 4.39 0 7.95 3.397 7.95 7.587 0 .585-.076 1.152-.208 1.699M16.714 15.635c-1.438 1.374-3.426 2.223-5.621 2.223-4.39 0-7.95-3.397-7.95-7.587 0-.585.076-1.152.207-1.7", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M4.571 10 3.142 8.572 1.714 10M17.428 10l1.429 1.429L20.285 10", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { DollarExchange };
//# sourceMappingURL=DollarExchange.js.map
